import { DefaultState } from './default-state.type';

export const defaultState: DefaultState = {
	commentPanelIsOpen: false,
	targetComponentId: '',
	comments: [],
	commentAdded: []
};
